exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ld-messages {\n  position: fixed;\n  width: 90%;\n  margin-left: 5%;\n  z-index: 200;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/layout/layout.component.css
// module id = 855
// module chunks = 0